exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-add-category[data-v-7eafda57]{padding:4px;text-align:center;border:1px solid #ff5722;color:#ff5722;border-radius:4px;font-size:.9rem;width:150px;margin:0 0 12px 8px}.btn-add-category[data-v-7eafda57]:hover{color:#fff;background-color:#ff5722}", ""]);

// exports
